module.exports = __webpack_public_path__ + "media/images/social/rss-63b1730c60c70bd3c8b6de6aacebcb27.svg";